import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://ecuidhamus.web.ua.pt/nodejs/'
    //baseURL: 'http://localhost:7000/'
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios.js